<div class="auth-wrapper">
    <div class="container-fluid ">
      <div class="row flex-row h-100">
        <div class=" col-md-12 p-0 d-md-block d-lg-block">
          <div class="bg2" style="background-image: url('assets/images/login-back.png')">
            <div class="overlay"></div>
            <app-lang></app-lang>

            <div class="col-xl-6 col-lg-6 col-md-9 my-auto">
              <div class="container-login">
                <div class="wrap-login">

                  <div class="loading-indicator" *ngIf="global.spinner">
                    <mat-progress-spinner mode="indeterminate" ></mat-progress-spinner>
                  </div>

                  <form #f="ngForm" novalidate (ngSubmit)="SendEmail(f)" class="login-form login-form-edit">
                    <a class="logo-centered d-flex align-items-center justify-content-center" [routerLink]="['/']">
                      <img src="assets/images/logo.png" class="" alt="">
                    </a>

                    <span class="login-form-title">{{'Password.changePassword' | translate}}</span>

                    <div class=" input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"><i class="ik ik-lock"></i></span>
                      </div>

                      <input class="form-control" type="Email" name="Email" placeholder="{{'employee.email' | translate}}" [(ngModel)]="email"  #Email="ngModel" style="font-family: initial;" required pattern="^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$">

                      <div  style=" color: #f28d1e; font-size: 12px;display: block; "  class="valid-feedback"  *ngIf=" Email.invalid && (Email.dirty || Email.touched)">
                        <span *ngIf="Email.errors.required"  >
                          {{'validation.enterValue' | translate}}
                        </span>
                        <span *ngIf="Email.errors.pattern"  >
                          {{'validation.invalidEmail' | translate}}
                        </span>
                        <span *ngIf="Email.errors.NotExist"  >
                          {{'validation.emailIsNotExist' | translate}}
                        </span>
                      </div>
                    </div>

                    <div class="d-flex justify-content-between">

                      <button type="submit" class="login-form-btn">
                        <i class="ik ik-corner-down-right"></i>
                        {{'Password.sendEmail' | translate}}
                      </button>

                      <a [routerLink]="['/login']">
                        <button class="login-form-btn" type="reset"> <i class="ik ik-corner-down-left"></i> {{'Password.cancel' | translate}}</button>
                      </a>

                    </div>


                  </form>

                </div>
              </div>
            </div>
          </div>


        </div>


      </div>
    </div>

  </div>
